module.exports = __webpack_public_path__ + "img/icon_zsdsj.acee1291.png";